import type { SocialNetwork } from "@/modules/companies/client/api/types"
import type { FunctionComponent } from "react"

import IconInstagram from "@jobteaser/ui-kit/assets/icons/jds_instagram_regular.svg"
import IconLinkedin from "@jobteaser/ui-kit/assets/icons/jds_linkedin_regular.svg"
import IconTiktok from "@jobteaser/ui-kit/assets/icons/jds_tiktok.svg"
import IconX from "@jobteaser/ui-kit/assets/icons/jds_x.svg"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/dist/module/components/Icon/Icon"

import { useCompanyExternalLinkTrack } from "@/modules/companies/client/hooks/tracking/useCompanyExternalLinkTrack"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./SocialNetworks.module.css"

export const SocialNetworkItem: FunctionComponent<SocialNetwork> = ({ type, url }) => {
  const companyExternalLinkTrack = useCompanyExternalLinkTrack()
  const { t } = useTranslation(["companies_client"])

  const socialNetworkName = type.split("_")[3].toLowerCase()
  const socialNetworkIcons: Record<string, string> = {
    instagram: IconInstagram.id,
    linkedin: IconLinkedin.id,
    ticktock: IconTiktok.id,
    twitter: IconX.id,
  }

  const deprecatedSocialNetworks = ["youtube", "facebook", "unspecified"]

  if (deprecatedSocialNetworks.includes(socialNetworkName)) {
    return null
  }

  return (
    <a
      href={url}
      className={styles.socialNetworks__link}
      rel="noreferrer noopener"
      target="_blank"
      onClick={() => companyExternalLinkTrack(url, socialNetworkName)}
      aria-label={`${socialNetworkName} ${t("companies_client.link.target_blank")}`}
    >
      <Icon size={ICON_SIZES.SMALL} role="graphics-symbol" xlinkHref={`#${socialNetworkIcons[socialNetworkName]}`} />
    </a>
  )
}
